angular.module("vgresiduos").controller("CollectionRequestEquipmentEditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `gestao-solicitacoes/equipamento/${$stateParams.id}`);
		};
	}
]);
